export default "__VITE_ASSET__CM$j8Tsm__"